import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { DELETE_IMAGES_SURVEYS } from './constants';
import {
  DeleteImagesSurveysDataActionTypes,
  DeleteImagesSurveysError,
  DeleteImagesSurveysState,
  DeleteImagesSurveysSuccess,
} from './types';

const initialState: DeleteImagesSurveysState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: DeleteImagesSurveysDataActionTypes,
  ): DeleteImagesSurveysState => {
    switch (action.type) {
      case DELETE_IMAGES_SURVEYS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case DELETE_IMAGES_SURVEYS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as DeleteImagesSurveysSuccess).payload;
        break;
      }
      case DELETE_IMAGES_SURVEYS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as DeleteImagesSurveysError).error;
        break;
      }
      case DELETE_IMAGES_SURVEYS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
